module.exports = __webpack_public_path__ + "76fbda7bacbb00db3b8e0d4420b46780.woff";